import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfig {
  static settings: any;
  constructor(private http: HttpClient) {}

  // Load config at bootstrap. Falls back to environment when the JSON is missing/unreachable.
  load(): Promise<void> {
    const jsonFile = `assets/config/config.${environment.name}.json`;
    return new Promise<void>((resolve) => {
      this.http.get(jsonFile).toPromise()
        .then((response: any) => {
          AppConfig.settings = response;
          resolve();
        })
        .catch((err: any) => {
          // Don’t fail bootstrap. Provide a safe fallback and log details.
          console.warn(`AppConfig: could not load '${jsonFile}'. Falling back to environment.`, {
            status: err?.status, statusText: err?.statusText, url: err?.url, error: err?.error
          });
          AppConfig.settings = { baseUrl: environment.baseUrl };
          resolve();
        });
    });
  }
}
